var readCookie = function(name) {
  var nameEQ = name + "="
  var ca = document.cookie.split(";")
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === " ") c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) {
      let value = c.substring(nameEQ.length, c.length)
      return value.replace(/\+/g, " ")
    }
  }
  return null
}

var setCookie = function(name, value, days) {
  var date, expires
  if (days) {
    date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = "; expires=" + date.toUTCString()
  } else {
    expires = ""
  }
  document.cookie = name + "=" + value + expires + "; path=/"
}


export { readCookie, setCookie }
